import React from "react";
import "./styles.scss";

/*interface Member {
  id: string;
  name: string;
}*/
interface IProps {
  name: string;
}

const MemberTag = (props: IProps) => {
  return (
    <div className="member-tag">
      <div>{props.name}</div>
    </div>
  );
};

export default MemberTag;
